import { createSlice } from "@reduxjs/toolkit";
import { stat } from "fs";

const persistentSlice = createSlice({
    name: "perisitent",
    initialState: {
        botLoginQue: "",
        handlerState: '',
        isUserHandler: false,
        isAuth: '',
        handleMode: '',
    },
    reducers: {
        handleBotLoginQue(state, action) {
            state.botLoginQue = action.payload
        },
        controlHandlerState(state, action) {
            state.handlerState = action.payload
        },
        handleIsUserHandler(state, action) {
            state.isUserHandler = action.payload
        },
        handleAuthDetails(state, action) {
            state.isAuth = action.payload
        },
        handleInteractionMode(state, action) {
            state.handleMode = action.payload
        }
    }
})
export const { handleBotLoginQue, controlHandlerState, handleIsUserHandler, handleAuthDetails, handleInteractionMode } = persistentSlice.actions;
export default persistentSlice.reducer;